// extracted by mini-css-extract-plugin
module.exports = {"saleItem":"Sale_saleItem__1U3F9","deleteBtn":"Sale_deleteBtn__3FtWc","deleteModalBody":"Sale_deleteModalBody__1nEgt"};